<template>
  <md-content :class="`panel ${color} ${scrollMode}-scroll border md-scrollbar ${hasBack && 'has-back'}`">
    <md-content :class="`panel-content-container ${backgroundColor} ${paddingMode}-padding bg md-scrollbar`">
      <div class="title-container">
        <div v-if="hasBack" class="back-container" @click="onBack()">
          <md-icon class="back-icon" :class="{disabled: backButtonDisabled}">arrow_back</md-icon>
        </div>
        <section-title v-if="title" :color="color" :text-color="titleColor">
          {{ title }}
          <template v-if="$slots['title-tooltip']" v-slot:tooltip>
            <slot name="title-tooltip" />
          </template>
        </section-title>
        <slot name="title" />
      </div>
      <div class="panel-content">
        <slot />
      </div>
    </md-content>
  </md-content>
</template>

<script>
import SectionTitle from '../SectionTitle.vue';

export default {
  name: 'panel',
  components: {
    SectionTitle,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'blue-4',
    },
    backgroundColor: {
      type: String,
      default: 'gray-3',
    },
    titleColor: {
      type: String,
      default: 'gray-7',
    },
    scrollMode: {
      type: String,
      default: 'container',
    },
    paddingMode: {
      type: String,
      default: 'vertical',
    },
    backButtonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasBack() {
      return !!this.$listeners.onBack;
    },
  },
  methods: {
    onBack() {
      if (this.backButtonDisabled) {
        return;
      }
      this.$emit('onBack');
    },
  },
};
</script>

<style scoped>
.panel {
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.title-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.back-container {
  margin-left: -20px;
  cursor: pointer;
  margin-right: 13px;
}

.back-icon {
  font-size: 32px !important;
}

.back-icon.disabled {
  color: rgba(0,0,0,0.34)
}

.panel-content-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-left: 35px;
  padding-right: 35px;
}

.panel-content-container.vertical-padding {
  padding-top: 35px;
  padding-bottom: 35px;
}

.panel-content-container.top-only-padding {
  padding-top: 35px;
}

.panel-content-container.bottom-only-padding {
  padding-bottom: 35px;
}

.panel-content {
  padding-top: 25px;
}

.section-title {
  text-transform: uppercase;
}

.panel.content-scroll .panel-content-container {
  height: 100%;
  overflow: auto;
}

.panel.content-scroll .panel-content {
  /* 50px = section title height */
  height: calc(100% - 50px);
}
</style>
